import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

/**
 * Type-led splash. The old version spun a ring around a raster logo; this
 * sets the wordmark itself and draws a single rule beneath it, which is both
 * lighter and consistent with the masthead the user lands on.
 */
function Loader({ isLoading, setIsLoading }) {
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1600);
    return () => clearTimeout(timer);
  }, [setIsLoading]);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          key="loader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-agri-forestDeep"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.p
            className="font-display text-[2rem] font-semibold tracking-[-0.03em] text-white sm:text-[2.75rem]"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            AgriHyphen<span className="text-agri-lime"> AI</span>
          </motion.p>

          {/* Rule wipes in left to right — a progress cue, not a spinner */}
          <div className="mt-6 h-px w-40 overflow-hidden bg-white/15 sm:w-56">
            <motion.div
              className="h-full w-full bg-agri-lime"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              style={{ transformOrigin: "left" }}
            />
          </div>

          <motion.p
            className="mt-6 font-mono text-[0.625rem] uppercase tracking-[0.18em] text-white/60"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            Hyphen Tech · Ngozi, Burundi
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Loader;
